import AppMonitor from './AppMonitor';
import { instrumentGlobalFetch } from './requestTracing';

/**
 * @returns {void}
 */
export default function initErrorMonitor() {
	AppMonitor.init();
	instrumentGlobalFetch();
}
